/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Outcome of a Parental Control gate (detail entry, playback or a protected
 * setting), per DRD 2.1, 2.2 and WEB-PC-048.
 */
enum ParentalGateDecision {
  /** The rating is still loading: hold the gate and decide nothing (WEB-PC-047). */
  PENDING = "PENDING",

  /** The action goes ahead. */
  AUTHORIZED = "AUTHORIZED",

  /** Show the PIN dialog; in playback, mute and pause first. */
  CHALLENGE_REQUIRED = "CHALLENGE_REQUIRED",

  /** A violation with no PIN payload to challenge against; no PIN entry is offered. */
  BLOCKED = "BLOCKED"
}

export { ParentalGateDecision };
